import Vue from 'vue'

export default {
    toast: {
        error(title, message, params) {
            var _params = Object.assign({
                icon: "icon-person",
                position: "topRight",
            }, params);
            Vue.$toast.error(message, title, _params);
        },
        success(title, message, params) {
            var _params = Object.assign({
                icon: "icon-person",
                position: "topRight",
            }, params);
            Vue.$toast.success(message, title, _params);
        },
        warning(title, message, params) {
            var _params = Object.assign({
                icon: "icon-person",
                position: "topRight",
            }, params);
            Vue.$toast.warning(message, title, _params);
        },
        info(title, message, params) {
            var _params = Object.assign({
                icon: "icon-person",
                position: "bottomLeft",
            }, params);
            Vue.$toast.info(message, title, _params);
        },
    },
    alert: {
        success(title, message) {
            swal({
                title: title,
                text: message,
                type: "success",
                icon: "success",
                buttons: false,
                dangerMode: false,
            })
        },
        error(title, message) {
            swal({
                title: title,
                text: message,
                type: "error",
                icon: "error",
                buttons: {
                    cancel: "Cerrar",
                },
                dangerMode: true,
            })
        },
        info(title, message) {
            swal({
                title: title,
                text: message,
                type: "info",
                icon: "info",
                buttons: false,
                dangerMode: false,
            })
        },
        warning(title, message) {
            swal({
                title: title,
                text: message,
                type: "warning",
                icon: "warning",
                buttons: false,
                dangerMode: false,
            })
        },
        confirm(title, message, confirmText, callback) {
            swal({
                title: title,
                text: message,
                type: "info",
                icon: "info",
                // confirmButtonText: confirmText,
                // button:confirmText,
                buttons: ["Cancelar", confirmText],
                dangerMode: false,
            }).then((willDelete) => {
                if (willDelete) {
                    callback();
                }
            });
        },
        confirm_danger(title, message, confirmText, callback) {
            swal({
                title: title,
                text: message,
                type: "error",
                icon: "warning",
                confirmButtonText: confirmText,
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    callback();
                }
            });
        },
        prompt(title, message, placeholder, callback) {
            swal({
                title: title,
                text: message,
                content: {
                    element: "input",
                    attributes: {
                        placeholder: placeholder || "Escribe aquí...",
                        type: "text", // Puedes cambiarlo a "number", "password", etc.
                    },
                },
                buttons: {
                    cancel: "Cancelar",
                    confirm: {
                        text: "Aceptar",
                        closeModal: true,
                    },
                },
                dangerMode: false,
            }).then((value) => {
                // value contiene el texto ingresado o null si se presiona "Cancelar"
                if (value !== null) {
                    callback(value);
                }
            });
        }
    }
}